<template>
  <div class="page-container">
    <div class="table-wrapper">
      <!-- 筛选查询区 -->
      <el-form :inline="true" :model="search" size="small" class="filter-bar" @submit.native.prevent>
        <el-form-item label="通道类型">
          <el-select v-model="search.channelType" placeholder="全部" clearable style="width:130px;">
            <el-option label="入金通道" :value="1"></el-option>
            <el-option label="出金通道" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支付方式">
          <el-select v-model="search.payMethod" placeholder="全部" clearable style="width:130px;">
            <el-option v-for="m in payMethods" :key="m" :label="m" :value="m"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="search.isDelete" placeholder="全部" clearable style="width:120px;">
            <el-option label="启用" :value="1"></el-option>
            <el-option label="禁用" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>

      <div class="table-header">
        <span class="table-title">通道时间策略列表</span>
        <div class="table-actions">
          <el-button v-auth="'payment:payChannelTimeConfig:save'" type="primary" size="small" icon="el-icon-plus" @click="openAdd">新增</el-button>
          <el-button size="small" icon="el-icon-refresh" @click="refresh">刷新</el-button>
        </div>
      </div>

      <el-table :data="tableData" border v-loading="loading" style="width:100%;">
        <el-table-column label="通道名称" min-width="140">
          <template slot-scope="{row}">
            <span style="font-weight:600;">{{ row.channelName || '【全局默认规则】' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="channelTypeName" label="通道类型" width="100">
          <template slot-scope="{row}">{{ row.channelTypeName || '--' }}</template>
        </el-table-column>
        <el-table-column label="支付方式" width="100">
          <template slot-scope="{row}"><span class="badge">{{ row.payMethod || '全部' }}</span></template>
        </el-table-column>
        <el-table-column label="配置模式" min-width="90">
          <template slot-scope="{row}">
            <span v-if="row.mode === 2" class="badge-mode-weekly">按周自定义</span>
            <span v-else class="badge-mode-daily">每天统一</span>
          </template>
        </el-table-column>
        <el-table-column label="服务时段" min-width="260">
          <template slot-scope="{row}">
            <el-tooltip :content="summaryOf(row)" placement="top">
              <span class="ct-summary">{{ summaryOf(row) }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="createUser" label="创建人" width="90">
          <template slot-scope="{row}"><span class="cell-muted">{{ row.createUser || '--' }}</span></template>
        </el-table-column>
        <el-table-column prop="updateUser" label="最后更新人" width="100">
          <template slot-scope="{row}"><span class="cell-muted">{{ row.updateUser || '--' }}</span></template>
        </el-table-column>
        <el-table-column label="创建时间" width="160">
          <template slot-scope="{row}"><span class="cell-muted">{{ fmtDateTime(row.createDate) }}</span></template>
        </el-table-column>
        <el-table-column label="最后更新时间" width="160">
          <template slot-scope="{row}"><span class="cell-muted">{{ fmtDateTime(row.updateDate) }}</span></template>
        </el-table-column>
        <el-table-column label="状态" width="80" align="center">
          <template slot-scope="{row}">
            <el-switch v-auth="'payment:payChannelTimeConfig:status'" v-model="row.isDelete" :active-value="1" :inactive-value="2" active-color="var(--brand-primary)" @change="toggleStatus(row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="130" fixed="right" align="center">
          <template slot-scope="{row}">
            <el-button v-auth="'payment:payChannelTimeConfig:edit'" type="text" size="small" style="color:var(--brand-primary);" @click="openEdit(row)">编辑</el-button>
            <el-button v-auth="'payment:payChannelTimeConfig:delete'" type="text" size="small" style="color:#dc2626;" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="(v)=>{pageSize=v;pageNum=1;fetchList()}" @current-change="(v)=>{pageNum=v;fetchList()}"
        :current-page="pageNum" :page-sizes="[15,30,50]" :page-size="pageSize" layout="total,sizes,prev,pager,next,jumper" :total="total"></el-pagination>
    </div>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :visible.sync="editVisible" width="880px" :close-on-click-modal="false" :title="editForm.id ? '通道时间策略配置' : '新增通道时间策略'">
      <div class="ct-modal-body">
        <div class="ct-section">
          <div class="ct-section-title">基础信息</div>
          <div class="ct-info-grid">
            <div class="ct-info-item">
              <label>通道类型 <span class="req">*</span></label>
              <el-select v-model="editForm.channelType" style="width:100%;" placeholder="请选择通道类型" @change="onChannelTypeChange">
                <el-option label="入金通道" :value="1"></el-option>
                <el-option label="出金通道" :value="2"></el-option>
              </el-select>
            </div>
            <div class="ct-info-item">
              <label>通道名称</label>
              <el-select v-model="editForm.payChannelId" style="width:100%;" placeholder="全局默认规则（不指定通道）" clearable filterable @change="onChannelChange">
                <el-option v-for="c in filteredChannelOptions" :key="c.id" :label="c.channelName" :value="c.id"></el-option>
              </el-select>
              <div class="form-tip">不选择通道即为「全局默认规则」</div>
            </div>
            <div class="ct-info-item">
              <label>支付方式 <span v-if="editForm.payChannelId" class="req">*</span></label>
              <el-select v-model="editForm.payMethod" style="width:100%;" :disabled="!editForm.payChannelId" placeholder="全部">
                <el-option v-for="m in payMethodOptions" :key="m" :label="m" :value="m"></el-option>
              </el-select>
            </div>
            <div class="ct-info-item">
              <label>状态</label>
              <el-radio-group v-model="editForm.isDelete">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="2">禁用</el-radio>
              </el-radio-group>
            </div>
            <div class="ct-info-item">
              <label>系统时区</label>
              <div class="ct-info-val">{{ displayTimezone }}</div>
            </div>
            <div class="ct-info-item">
              <label>生效机制</label>
              <div class="ct-info-val">{{ editForm.effectiveRule || '保存后即时生效' }}</div>
            </div>
          </div>
        </div>

        <div class="ct-section">
          <div class="ct-section-title">时间配置模式</div>
          <div class="ct-mode-cards">
            <div class="ct-mode-card" :class="{ active: editForm.mode === 1 }" @click="editForm.mode = 1">
              <div class="ct-mode-title">每天统一模式</div>
              <div class="ct-mode-desc">周一至周日执行相同时间规则</div>
            </div>
            <div class="ct-mode-card" :class="{ active: editForm.mode === 2 }" @click="editForm.mode = 2">
              <div class="ct-mode-title">按周自定义模式</div>
              <div class="ct-mode-desc">周一至周日分别独立设置</div>
            </div>
          </div>
        </div>

        <div class="ct-section">
          <div class="ct-section-title">时段详细配置</div>
          <template v-if="editForm.mode === 1">
            <div class="day-config">
              <el-radio-group v-model="editForm.daily.openType">
                <el-radio label="all">全天开放</el-radio>
                <el-radio label="none">全天关闭</el-radio>
                <el-radio label="custom">指定时间段</el-radio>
              </el-radio-group>
              <div v-if="editForm.daily.openType === 'custom'" class="slot-list">
                <div v-for="(slot, i) in editForm.daily.slots" :key="i" class="slot-row">
                  <el-time-picker v-model="editForm.daily.slots[i].start" format="HH:mm" value-format="HH:mm" placeholder="开始" :clearable="false" style="width:110px;"></el-time-picker>
                  <span class="slot-sep">至</span>
                  <el-time-picker v-model="editForm.daily.slots[i].end" format="HH:mm" value-format="HH:mm" placeholder="结束" :clearable="false" style="width:110px;"></el-time-picker>
                  <el-button type="text" size="small" style="color:#dc2626;padding:0 8px;" icon="el-icon-delete" @click="editForm.daily.slots.splice(i,1)"></el-button>
                </div>
                <el-button size="mini" type="primary" plain icon="el-icon-plus" :disabled="editForm.daily.slots.length >= 5" @click="addDailySlot">+ 添加时段（{{ editForm.daily.slots.length }}/5）</el-button>
                <div class="form-tip">单日最多 5 个时段，时段间不可重叠、不可跨天</div>
              </div>
            </div>
          </template>
          <template v-else-if="editForm.mode === 2">
            <div class="week-config">
              <div class="copy-bar">
                <span class="copy-label">快捷复制设置：</span>
                <el-select v-model="copySource" size="small" style="width:110px;">
                  <el-option v-for="w in weekdays" :key="w.key" :label="w.label" :value="w.key"></el-option>
                </el-select>
                <span class="copy-label">复制到</span>
                <el-checkbox-group v-model="copyTargets" size="small">
                  <el-checkbox v-for="w in weekdays" :key="w.key" :label="w.key">{{ w.label }}</el-checkbox>
                </el-checkbox-group>
                <el-button size="mini" type="primary" plain @click="applyCopy">应用</el-button>
              </div>
              <div v-for="w in weekdays" :key="w.key" class="weekday-row">
                <div class="weekday-label">{{ w.label }}</div>
                <el-radio-group v-model="editForm.weekly[w.key].openType" size="mini" class="weekday-open">
                  <el-radio-button label="all">全天开放</el-radio-button>
                  <el-radio-button label="none">全天关闭</el-radio-button>
                  <el-radio-button label="custom">指定时间段</el-radio-button>
                </el-radio-group>
                <div v-if="editForm.weekly[w.key].openType === 'custom'" class="slot-list inline">
                  <div v-for="(slot, i) in editForm.weekly[w.key].slots" :key="i" class="slot-row">
                    <el-time-picker v-model="editForm.weekly[w.key].slots[i].start" format="HH:mm" value-format="HH:mm" placeholder="开始" :clearable="false" style="width:100px;"></el-time-picker>
                    <span class="slot-sep">至</span>
                    <el-time-picker v-model="editForm.weekly[w.key].slots[i].end" format="HH:mm" value-format="HH:mm" placeholder="结束" :clearable="false" style="width:100px;"></el-time-picker>
                    <el-button type="text" size="small" style="color:#dc2626;padding:0 6px;" icon="el-icon-delete" @click="editForm.weekly[w.key].slots.splice(i,1)"></el-button>
                  </div>
                  <el-button size="mini" plain icon="el-icon-plus" :disabled="editForm.weekly[w.key].slots.length >= 3" @click="addWeekSlot(w.key)">+ 添加时段（{{ editForm.weekly[w.key].slots.length }}/3）</el-button>
                </div>
              </div>
              <div class="form-tip">单日最多 3 个时段，时段间不可重叠、不可跨天</div>
            </div>
          </template>
        </div>

        <div class="ct-section">
          <div class="ct-section-title">用户提示与非服务时间策略</div>
          <div class="form-group">
            <label>非服务时间拦截文案</label>
            <el-input type="textarea" v-model="editForm.offMsg" :rows="3" placeholder="非服务时间向客户展示的提示文案"></el-input>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="restoreDefaults">恢复默认</el-button>
        <el-button size="small" @click="editVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="saveEdit">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { channelTimeConfigList, channelTimeConfigDetail, channelTimeConfigAddOrUpdate, channelTimeConfigDelete, channelTimeConfigStatus } from '@/api/channelTimeConfig'
import { payChannelConfigList } from '@/api/payChannelConfig'

export default {
  name: 'ChannelTimeConfigList',
  data() {
    return {
      search: { channelType: null, payMethod: '', isDelete: null },
      payMethods: ['USDT', 'USDT-Polygon', 'USDT-ERC20', 'USDT-BEP20', 'USDT-TRC20', 'Bank', 'AliPay', 'WeChat'],
      weekdays: [
        { key: 'mon', label: '周一' },
        { key: 'tue', label: '周二' },
        { key: 'wed', label: '周三' },
        { key: 'thu', label: '周四' },
        { key: 'fri', label: '周五' },
        { key: 'sat', label: '周六' },
        { key: 'sun', label: '周日' }
      ],
      tableData: [], loading: false, total: 0,
      pageNum: 1, pageSize: 15,
      channelOptions: [],
      editVisible: false,
      editForm: {},
      copySource: 'mon',
      copyTargets: []
    }
  },
  computed: {
    filteredChannelOptions() {
      return this.channelOptions.filter(c => c.channelType === this.editForm.channelType)
    },
    payMethodOptions() {
      if (!this.editForm.payChannelId) return []
      const c = this.channelOptions.find(x => x.id === this.editForm.payChannelId)
      return c && c.payMethod ? [c.payMethod] : []
    },
    displayTimezone() {
      const tz = this.editForm.systemTimezone || this.getBrowserTimezone()
      try {
        const parts = new Intl.DateTimeFormat('en-US', { timeZone: tz, timeZoneName: 'shortOffset' }).formatToParts(new Date())
        const offset = parts.find(p => p.type === 'timeZoneName')
        return offset && offset.value ? tz + ' (' + offset.value + ')' : tz
      } catch (e) {
        return tz
      }
    }
  },
  created() {
    this.loadChannels()
    this.fetchList()
  },
  methods: {
    loadChannels() {
      payChannelConfigList({ pageNum: 1, pageSize: 500, isDelete: 1 }).then(res => {
        if (res.code === 0) this.channelOptions = res.result.list || []
      })
    },
    fetchList() {
      this.loading = true
      channelTimeConfigList({ pageNum: this.pageNum, pageSize: this.pageSize, ...this.search }).then(res => {
        this.loading = false
        if (res.code === 0) { this.tableData = res.result.list || []; this.total = res.result.total || 0 }
      })
    },
    handleSearch() { this.pageNum = 1; this.fetchList() },
    resetSearch() { this.search = { channelType: null, payMethod: '', isDelete: null }; this.pageNum = 1; this.fetchList() },
    refresh() { this.fetchList(); this.$message.success('刷新成功') },
    openAdd() {
      this.editForm = this.newDraft()
      this.copySource = 'mon'
      this.copyTargets = []
      this.editVisible = true
    },
    openEdit(row) {
      channelTimeConfigDetail(row.id).then(res => {
        if (res.code !== 0) return
        const d = res.result
        this.editForm = {
          id: d.id,
          payChannelId: d.payChannelId,
          channelType: d.channelType,
          payMethod: d.payMethod || '',
          mode: d.mode || 1,
          daily: this.safeParse(d.dailyConfig, this.defaultDay('all', [])),
          weekly: this.mergeWeek(this.safeParse(d.weeklyConfig, {})),
          offMsg: d.offMsg || '',
          effectiveRule: d.effectiveRule || '保存后即时生效',
          systemTimezone: d.systemTimezone || this.getBrowserTimezone(),
          isDelete: d.isDelete
        }
        this.copySource = 'mon'
        this.copyTargets = []
        this.editVisible = true
      })
    },
    toggleStatus(row) {
      channelTimeConfigStatus(row.id, row.isDelete).then(res => {
        if (res.code === 0) this.$message.success('状态已更新')
        else this.fetchList()
      })
    },
    handleDelete(row) {
      this.$confirm('确认删除通道「' + (row.channelName || '【全局默认规则】') + '」的时间策略配置？删除后不可恢复。', '提示', { type: 'warning' }).then(() => {
        channelTimeConfigDelete(row.id).then(res => {
          if (res.code === 0) { this.$message.success('删除成功'); this.fetchList() }
        })
      }).catch(() => {})
    },
    onChannelTypeChange() {
      this.editForm.payChannelId = null
      this.editForm.payMethod = ''
    },
    onChannelChange(id) {
      const c = this.channelOptions.find(x => x.id === id)
      this.editForm.payMethod = c ? c.payMethod : ''
    },
    addDailySlot() {
      if (this.editForm.daily.slots.length >= 5) return
      this.editForm.daily.slots.push({ start: '', end: '' })
    },
    addWeekSlot(day) {
      if (this.editForm.weekly[day].slots.length >= 3) return
      this.editForm.weekly[day].slots.push({ start: '', end: '' })
    },
    applyCopy() {
      if (!this.copyTargets.length) { this.$message.warning('请选择要复制到的星期'); return }
      const src = this.editForm.weekly[this.copySource]
      this.copyTargets.forEach(k => {
        if (k !== this.copySource) {
          this.editForm.weekly[k] = { openType: src.openType, slots: JSON.parse(JSON.stringify(src.slots)) }
        }
      })
      this.$message.success('复制成功')
    },
    restoreDefaults() {
      this.$confirm('确定恢复为默认配置（每天统一 · 全天开放）？当前修改将丢失。', '提示', { type: 'warning' }).then(() => {
        this.editForm.mode = 1
        this.editForm.daily = this.defaultDay('all', [])
        this.editForm.weekly = this.defaultWeek()
        this.$message.success('已恢复默认（每天统一、全天开放）')
      }).catch(() => {})
    },
    saveEdit() {
      if (!this.editForm.channelType) { this.$message.warning('请选择通道类型'); return }
      if (this.editForm.mode === 1) {
        if (this.editForm.daily.openType === 'custom' && !this.validateSlots(this.editForm.daily.slots, '每日')) return
      } else {
        for (const w of this.weekdays) {
          if (this.editForm.weekly[w.key].openType === 'custom' && !this.validateSlots(this.editForm.weekly[w.key].slots, w.label)) return
        }
      }
      const data = {
        id: this.editForm.id,
        payChannelId: this.editForm.payChannelId,
        channelType: this.editForm.channelType,
        mode: this.editForm.mode,
        dailyConfig: JSON.stringify(this.editForm.daily),
        weeklyConfig: JSON.stringify(this.editForm.weekly),
        offMsg: this.editForm.offMsg,
        effectiveRule: this.editForm.effectiveRule,
        systemTimezone: this.editForm.systemTimezone,
        isDelete: this.editForm.isDelete
      }
      channelTimeConfigAddOrUpdate(data).then(res => {
        if (res.code === 0) {
          this.$message.success(this.editForm.id ? '配置已保存，即时生效' : '新增成功，已即时生效')
          this.editVisible = false
          this.fetchList()
        }
      })
    },
    validateSlots(slots, label) {
      if (!slots || !slots.length) { this.$message.warning(label + '请至少添加一个时段'); return false }
      for (const s of slots) {
        if (!s.start || !s.end) { this.$message.warning(label + '存在未填写的时段'); return false }
        if (s.start >= s.end) { this.$message.warning(label + '时段开始时间必须早于结束时间，且不可跨天'); return false }
      }
      const sorted = slots.slice().sort((a, b) => a.start.localeCompare(b.start))
      for (let i = 1; i < sorted.length; i++) {
        if (sorted[i].start < sorted[i - 1].end) { this.$message.warning(label + '时段间不可重叠'); return false }
      }
      return true
    },
    defaultDay(openType, slots) { return { openType: openType || 'all', slots: slots || [] } },
    defaultWeek() {
      const o = {}
      this.weekdays.forEach(w => { o[w.key] = this.defaultDay('all', []) })
      return o
    },
    getBrowserTimezone() {
      try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || 'Asia/Shanghai'
      } catch (e) {
        return 'Asia/Shanghai'
      }
    },
    newDraft() {
      return {
        id: null,
        payChannelId: null,
        channelType: 1,
        payMethod: '',
        mode: 1,
        daily: this.defaultDay('all', []),
        weekly: this.defaultWeek(),
        offMsg: '',
        effectiveRule: '保存后即时生效',
        systemTimezone: this.getBrowserTimezone(),
        isDelete: 1
      }
    },
    mergeWeek(w) {
      const o = this.defaultWeek()
      this.weekdays.forEach(day => { if (w[day.key]) o[day.key] = w[day.key] })
      return o
    },
    safeParse(str, fallback) {
      if (!str) return fallback
      try { return JSON.parse(str) } catch (e) { return fallback }
    },
    daySummary(cfg) {
      cfg = cfg || {}
      if (cfg.openType === 'all') return '全天'
      if (cfg.openType === 'none') return '关闭'
      return (cfg.slots || []).map(s => s.start + '-' + s.end).join(' / ')
    },
    summaryOf(row) {
      if (row.mode === 2) {
        const w = this.safeParse(row.weeklyConfig, {})
        return this.weekdays.map(x => x.label + ' ' + this.daySummary(w[x.key])).join(' · ')
      }
      const daily = this.safeParse(row.dailyConfig, {})
      if (daily.openType === 'all') return '全天开放'
      if (daily.openType === 'none') return '全天关闭'
      const slots = daily.slots || []
      return '每日 ' + slots.map(s => s.start + '-' + s.end).join('、')
    },
    fmtDateTime(t) { return t ? String(t).replace('T', ' ').substring(0, 19) : '--' }
  }
}
</script>

<style scoped>
.page-container { background: #f4f6fb; min-height: calc(100vh - 84px); padding: 16px; }
.table-wrapper { background: #fff; border-radius: 10px; padding: 16px; box-shadow: 0 1px 3px rgba(0,0,0,0.04),0 4px 16px rgba(0,0,0,0.06); }
.filter-bar { margin-top: 4px; }
.table-header { display: flex; align-items: center; justify-content: space-between; margin: 12px 0; }
.table-title { font-size: 15px; font-weight: 600; color: #1a2236; }
.table-actions { display: flex; gap: 8px; align-items: center; }
.badge { display: inline-block; padding: 0 8px; height: 22px; line-height: 20px; font-size: 12px; color: #606266; background: #f4f4f5; border: 1px solid #e9e9eb; border-radius: 4px; }
.badge-mode-weekly { display: inline-block; padding: 2px 8px; border-radius: 4px; font-size: 12px; color: #d97706; background: rgba(245,158,11,0.12); }
.badge-mode-daily { display: inline-block; padding: 2px 8px; border-radius: 4px; font-size: 12px; color: var(--brand-primary); background: var(--brand-primary-a12); }
.cell-muted { font-size: 12px; color: #8a94a6; }
.ct-summary { display: block; max-width: 300px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 12px; }

.ct-modal-body { max-height: 72vh; overflow-y: auto; padding: 0 4px; }
.ct-section { margin-bottom: 20px; }
.ct-section-title { font-size: 14px; font-weight: 600; color: #1a2236; margin-bottom: 12px; padding-left: 10px; border-left: 3px solid var(--brand-primary); }
.ct-info-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px 16px; background: #f8fafc; border: 1px solid #e8ecf2; border-radius: 8px; padding: 14px 16px; }
.ct-info-item label { font-size: 12px; color: #9ca3af; display: block; margin-bottom: 6px; }
.ct-info-item .req { color: #f56c6c; }
.ct-info-val { font-size: 14px; font-weight: 600; color: #1a2236; line-height: 32px; }
.ct-mode-cards { display: flex; gap: 12px; }
.ct-mode-card { flex: 1; border: 1px solid #e8ecf2; border-radius: 8px; padding: 12px 14px; cursor: pointer; }
.ct-mode-card.active { border-color: var(--brand-primary); background: var(--brand-primary-a08); }
.ct-mode-title { font-weight: 600; font-size: 13px; color: #1a2236; }
.ct-mode-desc { font-size: 12px; color: #9ca3af; margin-top: 4px; }
.form-group label { font-size: 13px; color: #303133; display: block; margin-bottom: 8px; }
.form-tip { font-size: 12px; color: #909399; line-height: 1.4; margin-top: 4px; }
.day-config { padding: 4px 0; }
.slot-list { margin-top: 10px; }
.slot-row { display: flex; align-items: center; margin-bottom: 8px; }
.slot-sep { margin: 0 8px; color: #909399; }
.slot-list.inline { display: flex; flex-wrap: wrap; align-items: center; gap: 6px; margin-top: 0; margin-left: 16px; }
.slot-list.inline .slot-row { margin-bottom: 0; }
.copy-bar { display: flex; align-items: center; gap: 8px; padding: 8px 0; margin-bottom: 8px; }
.copy-label { font-size: 12px; color: #606266; }
.weekday-row { display: flex; align-items: flex-start; padding: 8px 0; border-bottom: 1px solid #f0f2f5; }
.weekday-label { width: 40px; font-size: 13px; color: #303133; line-height: 28px; flex-shrink: 0; }
.weekday-open { flex-shrink: 0; }
</style>
